var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarCustomCheckIcon1 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  fill: "#EAEAEA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-5824 -17336C-5824 -17337.1 -5823.1 -17338 -5822 -17338H10835C10836.1 -17338 10837 -17337.1 10837 -17336V7843C10837 7844.11 10836.1 7845 10835 7845H-5822C-5823.1 7845 -5824 7844.11 -5824 7843V-17336Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M-5822 -17337H10835V-17339H-5822V-17337ZM10836 -17336V7843H10838V-17336H10836ZM10835 7844H-5822V7846H10835V7844ZM-5823 7843V-17336H-5825V7843H-5823ZM-5822 7844C-5822.55 7844 -5823 7843.55 -5823 7843H-5825C-5825 7844.66 -5823.66 7846 -5822 7846V7844ZM10836 7843C10836 7843.55 10835.6 7844 10835 7844V7846C10836.7 7846 10838 7844.66 10838 7843H10836ZM10835 -17337C10835.6 -17337 10836 -17336.6 10836 -17336H10838C10838 -17337.7 10836.7 -17339 10835 -17339V-17337ZM-5822 -17339C-5823.66 -17339 -5825 -17337.7 -5825 -17336H-5823C-5823 -17336.6 -5822.55 -17337 -5822 -17337V-17339Z",
  fill: "black",
  fillOpacity: 0.1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4342_25114)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 913,
  transform: "translate(-544 -497)",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_4342_25114)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_4342_25114)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -19,
  y: -194,
  width: 262,
  height: 259,
  rx: 4,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.032 14.18C1.69467 14.18 2.30133 14.2687 2.852 14.446C3.40267 14.6233 3.874 14.8893 4.266 15.244C4.66733 15.5987 4.97533 16.042 5.19 16.574C5.414 17.0967 5.526 17.708 5.526 18.408C5.526 19.22 5.39533 19.92 5.134 20.508C4.87267 21.0867 4.518 21.5627 4.07 21.936C3.622 22.3 3.09933 22.5707 2.502 22.748C1.914 22.916 1.284 23 0.612 23H-1.978V14.18H1.032ZM-0.27 21.656H0.486C0.896667 21.656 1.29333 21.6093 1.676 21.516C2.068 21.4133 2.41333 21.2407 2.712 20.998C3.01067 20.7553 3.24867 20.424 3.426 20.004C3.61267 19.584 3.706 19.052 3.706 18.408C3.706 17.4747 3.44 16.7607 2.908 16.266C2.38533 15.7713 1.676 15.524 0.78 15.524H-0.27V21.656ZM12.8115 20.046H8.28947V20.102C8.28947 20.7087 8.47614 21.1613 8.84947 21.46C9.23214 21.7587 9.73147 21.908 10.3475 21.908C10.7115 21.908 11.0335 21.8753 11.3135 21.81C11.6028 21.7447 11.8781 21.656 12.1395 21.544L12.4615 22.706C12.1908 22.8273 11.8688 22.93 11.4955 23.014C11.1221 23.098 10.6881 23.14 10.1935 23.14C9.6988 23.14 9.23214 23.0747 8.79347 22.944C8.36414 22.8133 7.98614 22.608 7.65947 22.328C7.3328 22.048 7.07147 21.6933 6.87547 21.264C6.6888 20.8347 6.59547 20.3213 6.59547 19.724C6.59547 19.2013 6.6748 18.7253 6.83347 18.296C6.99214 17.8667 7.21614 17.498 7.50547 17.19C7.7948 16.882 8.1448 16.644 8.55547 16.476C8.96614 16.308 9.4188 16.224 9.91347 16.224C10.8001 16.224 11.5048 16.4947 12.0275 17.036C12.5501 17.5773 12.8115 18.3287 12.8115 19.29V20.046ZM11.1175 18.898C11.1175 18.702 11.0941 18.5153 11.0475 18.338C11.0008 18.1513 10.9261 17.988 10.8235 17.848C10.7208 17.708 10.5855 17.6007 10.4175 17.526C10.2588 17.442 10.0675 17.4 9.84347 17.4C9.42347 17.4 9.07814 17.54 8.80747 17.82C8.5368 18.1 8.37347 18.4687 8.31747 18.926L11.1175 18.898ZM17.1889 23.14C16.9182 23.14 16.6569 23.1073 16.4049 23.042C16.1622 22.9767 15.9569 22.888 15.7889 22.776V26.22H14.1509V16.308H15.4249L15.6209 17.092C15.8822 16.84 16.1809 16.6347 16.5169 16.476C16.8529 16.308 17.2355 16.224 17.6649 16.224C18.5422 16.224 19.2329 16.518 19.7369 17.106C20.2502 17.6847 20.5069 18.4967 20.5069 19.542C20.5069 20.1393 20.4135 20.662 20.2269 21.11C20.0495 21.558 19.8069 21.936 19.4989 22.244C19.2002 22.5427 18.8502 22.7667 18.4489 22.916C18.0475 23.0653 17.6275 23.14 17.1889 23.14ZM17.2449 17.498C16.9089 17.498 16.6149 17.582 16.3629 17.75C16.1109 17.9087 15.9195 18.0673 15.7889 18.226V21.53C15.9475 21.6607 16.1295 21.7587 16.3349 21.824C16.5402 21.88 16.7549 21.908 16.9789 21.908C17.2029 21.908 17.4222 21.866 17.6369 21.782C17.8515 21.698 18.0429 21.5673 18.2109 21.39C18.3882 21.2033 18.5282 20.9653 18.6309 20.676C18.7429 20.3773 18.7989 20.0133 18.7989 19.584C18.7989 18.968 18.6682 18.4687 18.4069 18.086C18.1549 17.694 17.7675 17.498 17.2449 17.498ZM21.9741 16.938C22.3848 16.714 22.8001 16.5413 23.2201 16.42C23.6401 16.2893 24.1021 16.224 24.6061 16.224C24.9981 16.224 25.3528 16.2707 25.6701 16.364C25.9875 16.448 26.2628 16.588 26.4961 16.784C26.7295 16.98 26.9068 17.2367 27.0281 17.554C27.1588 17.862 27.2241 18.24 27.2241 18.688V23H25.9221L25.7541 22.3H25.7121C25.2361 22.86 24.5595 23.14 23.6821 23.14C22.9821 23.14 22.4361 22.958 22.0441 22.594C21.6521 22.2207 21.4561 21.74 21.4561 21.152C21.4561 20.7787 21.5355 20.4567 21.6941 20.186C21.8528 19.9153 22.0675 19.6913 22.3381 19.514C22.6181 19.3367 22.9495 19.206 23.3321 19.122C23.7148 19.0287 24.1301 18.982 24.5781 18.982H25.5581V18.52C25.5581 18.156 25.4508 17.8993 25.2361 17.75C25.0215 17.5913 24.7321 17.512 24.3681 17.512C24.1068 17.512 23.8268 17.554 23.5281 17.638C23.2388 17.722 22.9168 17.8667 22.5621 18.072L21.9741 16.938ZM25.5721 20.032L24.8161 20.06C24.2001 20.0787 23.7708 20.186 23.5281 20.382C23.2855 20.5687 23.1641 20.7973 23.1641 21.068C23.1641 21.4133 23.2668 21.6467 23.4721 21.768C23.6775 21.8893 23.9155 21.95 24.1861 21.95C24.4568 21.95 24.7135 21.8847 24.9561 21.754C25.2081 21.614 25.4135 21.4227 25.5721 21.18V20.032ZM28.8621 23V16.35H30.1361L30.3461 17.596C30.5048 17.2133 30.7568 16.8913 31.1021 16.63C31.4475 16.3593 31.8768 16.224 32.3901 16.224C32.6141 16.224 32.8101 16.2473 32.9781 16.294C33.1461 16.3407 33.2861 16.392 33.3981 16.448L33.1181 17.792C33.0155 17.736 32.8895 17.6893 32.7401 17.652C32.5908 17.6053 32.4088 17.582 32.1941 17.582C31.7181 17.582 31.3168 17.7453 30.9901 18.072C30.6635 18.3987 30.5001 18.9167 30.5001 19.626V23H28.8621ZM38.481 17.554H36.647V20.886C36.647 21.2033 36.7217 21.4227 36.871 21.544C37.0297 21.656 37.2303 21.712 37.473 21.712C37.6597 21.712 37.8557 21.6933 38.061 21.656C38.2663 21.6187 38.439 21.5673 38.579 21.502L38.831 22.678C38.6537 22.7527 38.411 22.8273 38.103 22.902C37.8043 22.9673 37.4823 23 37.137 23C36.381 23 35.835 22.846 35.499 22.538C35.1723 22.23 35.009 21.768 35.009 21.152V17.554H34.001V16.35H35.009V14.278H36.647V16.35H38.481V17.554ZM41.5887 23H39.9367V16.35H41.2107L41.4207 17.232C41.7287 16.924 42.06 16.6813 42.4147 16.504C42.7694 16.3173 43.18 16.224 43.6467 16.224C44.1134 16.224 44.5054 16.3173 44.8227 16.504C45.14 16.6813 45.378 16.938 45.5367 17.274C45.854 16.9473 46.204 16.6907 46.5867 16.504C46.9694 16.3173 47.3894 16.224 47.8467 16.224C48.5467 16.224 49.0787 16.4153 49.4427 16.798C49.8067 17.1807 49.9887 17.7267 49.9887 18.436V23H48.3367V18.66C48.3367 18.3053 48.2527 18.0253 48.0847 17.82C47.9167 17.6147 47.66 17.512 47.3147 17.512C47.044 17.512 46.7734 17.5773 46.5027 17.708C46.232 17.8387 45.9894 18.0253 45.7747 18.268C45.784 18.3333 45.7887 18.394 45.7887 18.45C45.7887 18.4967 45.7887 18.5527 45.7887 18.618V23H44.1367V18.66C44.1367 18.3053 44.0527 18.0253 43.8847 17.82C43.7167 17.6147 43.46 17.512 43.1147 17.512C42.844 17.512 42.5734 17.5867 42.3027 17.736C42.0414 17.876 41.8034 18.072 41.5887 18.324V23ZM57.5732 20.046H53.0512V20.102C53.0512 20.7087 53.2379 21.1613 53.6112 21.46C53.9939 21.7587 54.4932 21.908 55.1092 21.908C55.4732 21.908 55.7952 21.8753 56.0752 21.81C56.3645 21.7447 56.6399 21.656 56.9012 21.544L57.2232 22.706C56.9525 22.8273 56.6305 22.93 56.2572 23.014C55.8839 23.098 55.4499 23.14 54.9552 23.14C54.4605 23.14 53.9939 23.0747 53.5552 22.944C53.1259 22.8133 52.7479 22.608 52.4212 22.328C52.0945 22.048 51.8332 21.6933 51.6372 21.264C51.4505 20.8347 51.3572 20.3213 51.3572 19.724C51.3572 19.2013 51.4365 18.7253 51.5952 18.296C51.7539 17.8667 51.9779 17.498 52.2672 17.19C52.5565 16.882 52.9065 16.644 53.3172 16.476C53.7279 16.308 54.1805 16.224 54.6752 16.224C55.5619 16.224 56.2665 16.4947 56.7892 17.036C57.3119 17.5773 57.5732 18.3287 57.5732 19.29V20.046ZM55.8792 18.898C55.8792 18.702 55.8559 18.5153 55.8092 18.338C55.7625 18.1513 55.6879 17.988 55.5852 17.848C55.4825 17.708 55.3472 17.6007 55.1792 17.526C55.0205 17.442 54.8292 17.4 54.6052 17.4C54.1852 17.4 53.8399 17.54 53.5692 17.82C53.2985 18.1 53.1352 18.4687 53.0792 18.926L55.8792 18.898ZM60.5926 23H58.9406V16.35H60.2286L60.4386 17.232C60.7559 16.9147 61.0966 16.6673 61.4606 16.49C61.8246 16.3127 62.2306 16.224 62.6786 16.224C63.3973 16.224 63.9526 16.4247 64.3446 16.826C64.7366 17.218 64.9326 17.778 64.9326 18.506V23H63.2806V18.702C63.2806 18.3473 63.1873 18.0627 63.0006 17.848C62.8233 17.624 62.5526 17.512 62.1886 17.512C61.9179 17.512 61.6426 17.5867 61.3626 17.736C61.0826 17.876 60.8259 18.0673 60.5926 18.31V23ZM70.4322 17.554H68.5982V20.886C68.5982 21.2033 68.6729 21.4227 68.8222 21.544C68.9809 21.656 69.1815 21.712 69.4242 21.712C69.6109 21.712 69.8069 21.6933 70.0122 21.656C70.2175 21.6187 70.3902 21.5673 70.5302 21.502L70.7822 22.678C70.6049 22.7527 70.3622 22.8273 70.0542 22.902C69.7555 22.9673 69.4335 23 69.0882 23C68.3322 23 67.7862 22.846 67.4502 22.538C67.1235 22.23 66.9602 21.768 66.9602 21.152V17.554H65.9522V16.35H66.9602V14.278H68.5982V16.35H70.4322V17.554Z",
  fill: "#49454E"
}))), /*#__PURE__*/React.createElement("rect", {
  x: -544,
  y: -497,
  width: 1440,
  height: 925,
  fill: "black",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_4342_25114)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -82,
  y: -198,
  width: 515,
  height: 322,
  rx: 12,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_4342_25114)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3_4342_25114)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -19.5,
  y: -115,
  width: 390,
  height: 149,
  rx: 4,
  fill: "#F1F5F8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 18,
  height: 18,
  rx: 4,
  fill: "#E1DFF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13.9L3.5 9.9L4.9 8.5L7.5 11.1L14.1 4.5L15.5 5.9L7.5 13.9Z",
  fill: "#6B5CE8"
})))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4342_25114",
  x: -23,
  y: -198,
  width: 270,
  height: 267,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4342_25114"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4342_25114",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_4342_25114",
  x: -23.5,
  y: -119,
  width: 398,
  height: 157,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4342_25114"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4342_25114",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4342_25114"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 913,
  fill: "white",
  transform: "translate(-544 -497)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_4342_25114"
}, /*#__PURE__*/React.createElement("rect", {
  x: -19,
  y: -194,
  width: 262,
  height: 259,
  rx: 4,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_4342_25114"
}, /*#__PURE__*/React.createElement("rect", {
  x: -82,
  y: -198,
  width: 515,
  height: 322,
  rx: 12,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3_4342_25114"
}, /*#__PURE__*/React.createElement("rect", {
  x: -19.5,
  y: -115,
  width: 390,
  height: 149,
  rx: 4,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarCustomCheckIcon1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_custom_check_icon_1.74dedf5779a5964fc8c771ae707e85d8.svg";